import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/store';
import routes from './routes';

Vue.use(Router);

const getInitialPageByRole = (context) => {
    const contextRole = context.roles.length ? context.roles[0].name : null;
    let route = '/';

    switch (contextRole) {
        case 'appointment_manager':
            route = '/appointments';
            break;
        case 'insured':
        case 'super_insured':
        case 'insurer_admin':
            route = '/claim-dashboard';
            break;
        case 'fnol_admin':
            route = '/micro-list';
            break;
        case 'policy_viewer':
            route = `/policies`;
            break;
        default:
            route = '/';
    }
    return route;
};

const goRightPage = (to, next, context, isAdmin) => {
    if (to.path === '/') {
        let path = '';

        if (isAdmin) {
            path = '/dashboard';
        } else {
            path = context.canRead('survey_management_feeds')
                ? '/feeds'
                : getInitialPageByRole(context);
        }

        next(path);
    } else {
        next();
    }
};

const router = new Router({
    routes,
});

router.beforeEach((to, from, next) => {
    const { context } = store.getters;
    const { isAdmin } = context;

    store.dispatch('startHeartbeat');

    if (to.meta && to.meta.name == 'share') {
        next();
    } else if (!store.state.loaded) {
        store.dispatch('fetchContext').then(() => {
            goRightPage(to, next, context, isAdmin);
        });
        store.dispatch('fetchAgoraConfig');
    } else {
        goRightPage(to, next, context, isAdmin);
    }
});

export default router;
